import { Component, OnInit, ViewChild } from "@angular/core";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { RoleService } from 'src/app/services/role-service';
import { EmployeService } from 'src/app/services/employe-service';
import { RoleEntite } from 'src/app/entites/role';
import { TacheEntite } from 'src/app/entites/tache';
import { EmployeEntite } from 'src/app/entites/employe';
import { DetailRoleComponent } from './detail-role.component';

@Component({
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class RolesComponent extends BaseComponent implements OnInit {

    roles: RoleEntite[] = [];
    taches: TacheEntite[] = [];
    employes: EmployeEntite[] = [];
    selectionRole: RoleEntite;

    menuContextuel: MenuItem[];
    loaded: boolean = false;
    dialogRef: DynamicDialogRef;

    @ViewChild('dt') table: Table;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent,
        private breadcrumbService: BreadcrumbService,
        private roleService: RoleService,
        private employeService: EmployeService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {
        super(sdb, profilService, route, routerService, appMain);
        
        this.breadcrumbService.setItems([
            { label: 'Admin', routerLink: '/admin' },
            { label: 'Rôles' }
        ]);
    }

    ngOnInit() {
        this.verifierAccesPage('admin_roles');
        this.chargerDonnees();
        this.initialiserMenuContextuel();
    }

    /**
     * Charge toutes les données nécessaires
     */
    chargerDonnees() {
        // Charger les rôles
        this.roleService.obtenirRoles().subscribe({
            next: (roles) => {
                this.roles = roles;
                this.calculerStatistiquesRoles();
                this.CompleterChargement();
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: 'Erreur lors du chargement des rôles'
                });
            }
        });

        // Charger les tâches
        this.roleService.obtenirTaches().subscribe({
            next: (taches) => {
                this.taches = taches;
            },
            error: (error) => {
                console.error('Erreur lors du chargement des tâches', error);
            }
        });

        // Charger les employés
        this.employes = this.sdb.Employes();
    }

    /**
     * Calcule les statistiques pour chaque rôle (nombre d'employés, etc.)
     */
    calculerStatistiquesRoles() {
        if (this.roles) {
            this.roles.forEach(role => {
                // Utiliser la liste d'employés directement attachée au rôle
                (role as any).nbEmployes = role.employes ? role.employes.length : 0;
                (role as any).nbTaches = role.taches ? role.taches.length : 0;
            });
        }
    }

    /**
     * Initialise le menu contextuel
     */
    initialiserMenuContextuel() {
        this.menuContextuel = [
            { 
                label: 'Modifier', 
                icon: 'pi pi-fw pi-pencil', 
                command: () => this.ouvrirDetail(this.selectionRole)
            },
            { separator: true },
            { 
                label: 'Supprimer', 
                icon: 'pi pi-fw pi-trash',
                command: () => this.confirmerSuppression(this.selectionRole),
                disabled: this.selectionRole?.nom === 'SIHC_Administrateur'
            }
        ];
    }

    /**
     * Ouvre le dialogue de détail/modification d'un rôle
     */
    ouvrirDetail(role?: RoleEntite) {
        this.dialogRef = this.dialogService.open(DetailRoleComponent, {
            header: role ? `Modifier le rôle: ${role.nom}` : 'Nouveau rôle',
            width: '80%',
            data: {
                role: role,
                taches: this.taches,
                employes: this.employes
            }
        });

        this.dialogRef.onClose.subscribe((result) => {
            if (result) {
                this.chargerDonnees(); // Recharger les données si modification
            }
        });
    }

    /**
     * Confirme la suppression d'un rôle
     */
    confirmerSuppression(role: RoleEntite) {
        if (role.nom === 'SIHC_Administrateur') {
            this.messageService.add({
                severity: 'warn',
                summary: 'Action non autorisée',
                detail: 'Le rôle SIHC_Administrateur ne peut pas être supprimé'
            });
            return;
        }

        this.confirmationService.confirm({
            message: `Êtes-vous sûr de vouloir supprimer le rôle "${role.nom}" ?`,
            header: 'Confirmation de suppression',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.supprimerRole(role);
            }
        });
    }

    /**
     * Supprime un rôle
     */
    supprimerRole(role: RoleEntite) {
        this.roleService.supprimerRole(role.roleId).subscribe({
            next: (message) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Succès',
                    detail: 'Rôle supprimé avec succès'
                });
                this.chargerDonnees();
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Erreur',
                    detail: error.message || 'Erreur lors de la suppression du rôle'
                });
            }
        });
    }

    /**
     * Ajouter un nouveau rôle
     */
    ajouterRole() {
        this.ouvrirDetail();
    }
}
